import { render, staticRenderFns } from "./SuccessRedsys.vue?vue&type=template&id=58618919&scoped=true&"
import script from "./SuccessRedsys.vue?vue&type=script&lang=js&"
export * from "./SuccessRedsys.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58618919",
  null
  
)

export default component.exports